import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DEFAULT_LANGUAGE, ROUTE_PATHS } from './route-paths';
import { HomepageComponent } from './components/pages/dynamic/homepage/homepage.component';

export const routes: Routes = [
  // Turkish homepage at root
  {
    path: '',
    component: HomepageComponent,
    pathMatch: 'full',
    data: {
      title: 'dotCREA - Pazaryeri Entegrasyonu | E-Ticaret Entegrasyonu',
      description: 'Tüm pazaryerlerine kolayca entegre olun! dotCREA ile ürünlerinizi tek bir platformdan yönetin, siparişlerinizi takip edin ve iş süreçlerinizi optimize ederek satışlarınızı artırın. Zahmetsiz pazaryeri entegrasyonu şimdi sizinle!',
      robots: 'index, follow'
    }
  },
  // Redirect /tr to root for backward compatibility
  {
    path: 'tr',
    redirectTo: '',
    pathMatch: 'full'
  },
  // English homepage
  {
    path: 'en',
    component: HomepageComponent,
    data: {
      title: 'dotCREA - Marketplace and E-Commerce Integration',
      description: 'Seamlessly integrate your products with all marketplaces using dotCREA, and manage your orders quickly and easily from a single platform. Optimize your business processes and boost your sales with our marketplace integration system.',
      robots: 'index, follow'
    }
  },
  // Turkish routes (at root level)
  {
    path: '',
    children: [
      // {
      //   path: 'blog',
      //   loadChildren: () => import('./components/pages/blog/blog-list/blog-list.module').then(m => m.BlogListModule),
      //   data: {
      //     title: 'Blog - dotCREA',
      //     description: 'E-ticaret, entegrasyon çözümleri ve dijital ticaret hakkında en güncel blog yazıları ve haberler.',
      //     robots: 'index, follow'
      //   }
      // },
      // {
      //   path: 'blog/:slug',
      //   loadChildren: () => import('./components/pages/blog/blog-detail/blog-detail.module').then(m => m.BlogDetailModule),
      //   data: {
      //     robots: 'index, follow'
      //   }
      // },
      {
        path: 'fiyatlandirma',
        loadChildren: () => import('./components/pages/e-commerce/pricing-page/pricing-page.module').then(m => m.PricingPageModule),
        data: {
          title: 'Fiyatlandırma - dotCREA',
          description: 'dotCREA ile pazaryeri entegrasyonlarınız için en uygun fiyatlandırma çözümlerini keşfedin. İşletmenizi büyütmek için esnek fiyat seçenekleri sunuyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'entegrasyon-paketleri-fiyatlandirma',
        loadChildren: () => import('./components/pages/pricing/integration-pricing/integration-pricing.module').then(m => m.IntegrationPricingModule),
        data: {
          title: 'Entegrasyon Paketleri Fiyatlandırma - dotCREA',
          description: 'Pazaryeri, e-ticaret, kargo ve muhasebe entegrasyonları için uygun fiyatlı paket seçenekleri. İhtiyacınıza özel çözümler.',
          robots: 'index, follow'
        }
      },
      {
        path: 'iletisim',
        loadChildren: () => import('./components/pages/contact-page/contact-page.module').then(m => m.ContactPageModule),
        data: {
          title: 'İletişim - dotCREA',
          description: 'Bizimle iletişime geçin! dotCREA hakkında daha fazla bilgi almak veya destek talep etmek için buradayız. Sorularınızı yanıtlamaktan mutluluk duyarız.',
          robots: 'index, follow'
        }
      },
      {
        path: 'pazaryeri-cozumleri',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-integration/page-solutions-integration.module').then(m => m.PageSolutionsIntegrationModule),
        data: {
          title: 'Pazaryeri Çözümleri - dotCREA',
          description: 'Tüm pazaryerleri ile kolay entegrasyon sağlayarak satışlarınızı artırın. dotCREA’nin kapsamlı pazaryeri çözümleri ile işinizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'kargo-entegrasyonlari',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-cargo/page-solutions-cargo.module').then(m => m.PageSolutionsCargoModule),
        data: {
          title: 'Kargo Entegrasyonları - dotCREA',
          description: 'Kargo süreçlerinizi optimize edin. dotCREA’nin kargo entegrasyonları sayesinde hızlı ve güvenilir gönderimler yapın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'xml-entegrasyonlari',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-xml/page-solutions-xml.module').then(m => m.PageSolutionsXmlModule),
        data: {
          title: 'XML Entegrasyonları - dotCREA',
          description: 'Ürünlerinizi verimli bir şekilde yönetmek için XML entegrasyonları ile kolaylık sağlayın. dotCREA ile tüm süreçlerinizi basit hale getirin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'webservis-entegrasyonlari',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-webservice/page-solutions-webservice.module').then(m => m.PageSolutionsWebserviceModule),
        data: {
          title: 'Web Servis Entegrasyonları - dotCREA',
          description: 'Gelişmiş web servis entegrasyonları ile iş süreçlerinizi hızlandırın. dotCREA ile tüm verilerinizi entegre edin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'analistik-entegrasyonlari',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-analytics/page-solutions-analytics.module').then(m => m.PageSolutionsAnalyticsModule),
        data: {
          title: 'Analitik Entegrasyonları - dotCREA',
          description: 'Veri analitiği ile işinizi yönlendirin. dotCREA’nin analitik çözümleri ile performansınızı artırın ve stratejik kararlar alın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'katalog-yonetimi',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-catalog/page-solutions-catalog.module').then(m => m.PageSolutionsCatalogModule),
        data: {
          title: 'Katalog Yönetimi - dotCREA',
          description: 'Ürün kataloglarınızı etkili bir şekilde yönetin. dotCREA ile tüm ürün bilgilerinizi tek bir platformda toplayın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'stok-ve-fiyat-yonetimi',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-stock/page-solutions-stock.module').then(m => m.PageSolutionsStockModule),
        data: {
          title: 'Stok ve Fiyat Yönetimi - dotCREA',
          description: 'Stok seviyelerinizi ve fiyatlarınızı kolayca yönetin. dotCREA ile işinizi verimli bir şekilde kontrol edin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'on-muhasebe-sistemi',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-accounting/page-solutions-accounting.module').then(m => m.PageSolutionsAccountingModule),
        data: {
          title: 'Ön Muhasebe Sistemi - dotCREA',
          description: 'Muhasebe süreçlerinizi kolaylaştırın. dotCREA’nin ön muhasebe sistemi ile finansal yönetiminizi geliştirin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'e-fatura-aktarim-sistemi',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-einvoice/page-solutions-einvoice.module').then(m => m.PageSolutionsEinvoiceModule),
        data: {
          title: 'E-Fatura Aktarım Sistemi - dotCREA',
          description: 'E-fatura süreçlerinizi hızlandırın. dotCREA ile e-faturalarınızı güvenli bir şekilde yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'trendyol-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/trendyol-integration/trendyol-integration.module').then(m => m.TrendyolIntegrationModule),
        data: {
          title: 'Trendyol Entegrasyonu - dotCREA',
          description: 'Trendyol ile sorunsuz bir entegrasyon sağlayarak ürünlerinizi hızla listeleyin. dotCREA’nin Trendyol entegrasyonu ile satışlarınızı artırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'hepsiburada-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/hepsiburada-integration/hepsiburada-integration.module').then(m => m.HepsiburadaIntegrationModule),
        data: {
          title: 'Hepsiburada Entegrasyonu - dotCREA',
          description: 'Hepsiburada ile hızlı ve güvenilir entegrasyon çözümleri sunarak satışlarınıza değer katın. dotCREA ile işinizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'n11-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/n11-integration/n11-integration.module').then(m => m.N11IntegrationModule),
        data: {
          title: 'N11 Entegrasyonu - dotCREA',
          description: 'N11 platformu üzerinden ürünlerinizi kolayca yönetin. dotCREA ile N11 entegrasyonu sayesinde satışlarınızı artırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ciceksepeti-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/ciceksepeti-integration/ciceksepeti-integration.module').then(m => m.CiceksepetiIntegrationModule),
        data: {
          title: 'Çiçeksepeti Entegrasyonu - dotCREA',
          description: 'Çiçeksepeti üzerinden satışlarınızı artırın. dotCREA’nin entegrasyon çözümleri ile tüm süreci kolayca yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'pttavm-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/pttavm-integration/pttavm-integration.module').then(m => m.PttavmIntegrationModule),
        data: {
          title: 'PTTAVM Entegrasyonu - dotCREA',
          description: 'PTTAVM ile entegrasyon yaparak ürünlerinizi hızla listeleyin. dotCREA ile tüm süreçlerinizi kolayca yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'akakce-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/akakce-integration/akakce-integration.module').then(m => m.AkakceIntegrationModule),
        data: {
          title: 'Akakçe Entegrasyonu - dotCREA',
          description: 'Akakçe platformu üzerinden ürünlerinizi etkili bir şekilde yönetin. dotCREA ile entegrasyonun avantajlarından faydalanın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'amazon-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/marketplace/amazon-integration/amazon-integration.module').then(m => m.AmazonIntegrationModule),
        data: {
          title: 'Amazon Entegrasyonu - dotCREA',
          description: 'Amazon’da daha fazla görünürlük kazanın. dotCREA’nin Amazon entegrasyonu ile satışlarınızı artırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'rgsyazilim-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/rgs/rgs.module').then(m => m.RgsModule),
        data: {
          title: 'RGS Yazılım Entegrasyonu - dotCREA',
          description: 'RGS yazılım ile entegre olarak iş süreçlerinizi kolaylaştırın. dotCREA ile sorunsuz entegrasyon çözümleri sunun.',
          robots: 'index, follow'
        }
      },
      {
        path: 'opencart-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/opencart/opencart.module').then(m => m.OpencartModule),
        data: {
          title: 'OpenCart Entegrasyonu - dotCREA',
          description: 'OpenCart platformunda ürünlerinizi etkin bir şekilde yönetin. dotCREA ile tüm süreçlerinizi hızlandırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify',
        loadChildren: () => import('./components/pages/shopify/shopify-main.module').then(m => m.ShopifyMainModule),
        data: {
          title: 'Shopify E-Ticaret Çözümleri | Mağaza Kurulumu, Tema Geliştirme ve Entegrasyon - dotCREA',
          description: 'Profesyonel Shopify hizmetleri: Mağaza kurulumu, özel tema geliştirme, uygulama entegrasyonu, platform geçişi ve 7/24 teknik destek. Shopify uzmanlarıyla e-ticaret sitenizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify/shopify.module').then(m => m.ShopifyModule),
        data: {
          title: 'Shopify Entegrasyonu - dotCREA',
          description: 'Shopify ile mükemmel entegrasyon sağlayarak e-ticaret sitenizi güçlendirin. dotCREA ile satışlarınızı artırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-uygulama-gelistirme',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-app-development/shopify-app-development.module').then(m => m.ShopifyAppDevelopmentModule),
        data: {
          title: 'Shopify Uygulama Geliştirme - dotCREA',
          description: 'Shopify mağazanız için özel uygulama geliştirme hizmetleri. Modern teknolojilerle işletmenize özel çözümler sunuyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-magaza-kurulumu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-store-setup/shopify-store-setup.module').then(m => m.ShopifyStoreSetupModule),
        data: {
          title: 'Shopify Mağaza Kurulumu - dotCREA',
          description: 'Profesyonel Shopify mağazanızı kurmak için kapsamlı kurulum hizmetleri. Hızlı ve güvenli mağaza açılışı.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-gecis',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-migration/shopify-migration.module').then(m => m.ShopifyMigrationModule),
        data: {
          title: 'Shopify\'a Geçiş (Migrate) - dotCREA',
          description: 'Mevcut e-ticaret platformunuzdan Shopify\'a sorunsuz geçiş hizmetleri. Veri kaybı olmadan güvenli taşıma.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-tema-gelistirme',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-theme-development/shopify-theme-development.module').then(m => m.ShopifyThemeDevelopmentModule),
        data: {
          title: 'Shopify Tema Geliştirme - dotCREA',
          description: 'Markanıza özel, benzersiz Shopify temaları geliştiriyoruz. Modern ve performanslı tema çözümleri.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-tema-ozellestirme',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-theme-customization/shopify-theme-customization.module').then(m => m.ShopifyThemeCustomizationModule),
        data: {
          title: 'Shopify Tema Özelleştirme - dotCREA',
          description: 'Mevcut Shopify temanızı ihtiyaçlarınıza göre özelleştiriyoruz. Tasarım ve fonksiyon iyileştirmeleri.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-bakim-destek',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-maintenance/shopify-maintenance.module').then(m => m.ShopifyMaintenanceModule),
        data: {
          title: 'Shopify Bakım ve Destek - dotCREA',
          description: 'Shopify mağazanız için kapsamlı bakım ve teknik destek hizmetleri. 7/24 profesyonel destek.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-plus',
        loadChildren: () => import('./components/pages/shopify-plus/shopify-plus/shopify-plus.module').then(m => m.ShopifyPlusModule),
        data: {
          title: 'Shopify Plus Nedir? - Enterprise E-ticaret Platformu',
          description: 'Shopify Plus ile enterprise seviye e-ticaret çözümü. Büyük ölçekli işletmeler için özel özellikler, yüksek performans ve sınırsız ölçeklenebilirlik.',
          robots: 'index, follow'
        }
      },
      {
        path: 'enterprise-cozumleri',
        loadChildren: () => import('./components/pages/shopify-plus/enterprise-solutions/enterprise-solutions.module').then(m => m.EnterpriseSolutionsModule),
        data: {
          title: 'Enterprise E-ticaret Çözümleri - Shopify Plus',
          description: 'Büyük ölçekli işletmeler için özel tasarlanmış enterprise e-ticaret çözümleri. ERP entegrasyonu, özel geliştirme ve dedike destek.',
          robots: 'index, follow'
        }
      },
      {
        path: 'b2b-e-ticaret',
        loadChildren: () => import('./components/pages/shopify-plus/b2b-ecommerce/b2b-ecommerce.module').then(m => m.B2bEcommerceModule),
        data: {
          title: 'B2B E-ticaret Çözümleri - Shopify Plus',
          description: 'Toptan satış ve kurumsal müşteriler için B2B e-ticaret platformu. Özel fiyatlandırma, esnek ödeme ve hızlı sipariş özellikleri.',
          robots: 'index, follow'
        }
      },
      {
        path: 'toptan-satis-cozumleri',
        loadChildren: () => import('./components/pages/shopify-plus/wholesale-solutions/wholesale-solutions.module').then(m => m.WholesaleSolutionsModule),
        data: {
          title: 'Toptan Satış Çözümleri - Shopify Plus',
          description: 'Bayiler ve toptan müşteriler için özel e-ticaret platformu. Kademeli fiyatlandırma, bayi portalı ve otomatik sipariş yönetimi.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-plus-gecis',
        loadChildren: () => import('./components/pages/shopify-plus/shopify-plus-migration/shopify-plus-migration.module').then(m => m.ShopifyPlusMigrationModule),
        data: {
          title: 'Shopify Plus\'a Geçiş (Migration) - Güvenli Platform Taşıma',
          description: 'Mevcut e-ticaret platformunuzdan Shopify Plus\'a sorunsuz geçiş. Sıfır veri kaybı, SEO koruması ve minimal kesinti ile migration.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ozel-gelistirme',
        loadChildren: () => import('./components/pages/shopify-plus/custom-development/custom-development.module').then(m => m.CustomDevelopmentModule),
        data: {
          title: 'Özel Shopify Plus Geliştirme - Custom Development',
          description: 'İşletmenize özel Shopify Plus geliştirme hizmetleri. Özel uygulamalar, API entegrasyonları ve headless commerce çözümleri.',
          robots: 'index, follow'
        }
      },
      {
        path: 'wix-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/wix/wix.module').then(m => m.WixModule),
        data: {
          title: 'Wix Entegrasyonu - dotCREA',
          description: 'Wix üzerinden ürünlerinizi yönetmek için dotCREA’nin entegrasyon çözümlerini keşfedin. İşinizi kolaylaştırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'woocommerce-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/woocommerce/woocommerce.module').then(m => m.WoocommerceModule),
        data: {
          title: 'WooCommerce Entegrasyonu - dotCREA',
          description: 'WooCommerce ile etkili bir entegrasyon sağlayarak satışlarınızı artırın. dotCREA ile tüm süreçlerinizi yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'paytr-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/payment/paytr-integration/paytr-integration.module').then(m => m.PaytrIntegrationModule),
        data: {
          title: 'PayTR Entegrasyonu - dotCREA',
          description: 'PayTR ile ödeme süreçlerinizi hızlandırın. dotCREA’nin entegrasyon çözümleri ile güvenli ödemeler yapın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'bizimhesap-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/accounting/bizimhesap/bizimhesap.module').then(m => m.BizimhesapModule),
        data: {
          title: 'BizimHesap Entegrasyonu - dotCREA',
          description: 'BizimHesap ile sorunsuz bir entegrasyon sağlayarak muhasebe işlemlerinizi kolaylaştırın. dotCREA ile işinizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'dia-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/accounting/dia/dia.module').then(m => m.DiaModule),
        data: {
          title: 'DIA Entegrasyonu - dotCREA',
          description: 'DIA yazılımı ile entegrasyon yaparak tüm süreçlerinizi optimize edin. dotCREA ile iş akışınızı hızlandırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'edm-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/accounting/edm/edm.module').then(m => m.EdmModule),
        data: {
          title: 'EDM Entegrasyonu - dotCREA',
          description: 'EDM ile güçlü bir entegrasyon sağlayarak iş süreçlerinizi kolaylaştırın. dotCREA ile verimliliğinizi artırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'parasut-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/accounting/parasut/parasut.module').then(m => m.ParasutModule),
        data: {
          title: 'Parasut Entegrasyonu - dotCREA',
          description: 'Parasut ile entegrasyon sağlayarak muhasebe süreçlerinizi kolayca yönetin. dotCREA ile tüm süreçlerinizi hızlandırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'uyumsoft-entegrasyonu',
        loadChildren: () => import('./components/pages/integrations/accounting/uyumsoft/uyumsoft.module').then(m => m.UyumsoftModule),
        data: {
          title: 'Uyumsoft Entegrasyonu - dotCREA',
          description: 'Uyumsoft ile entegrasyon yaparak işletmenizi güçlendirin. dotCREA ile tüm süreçlerinizi kolayca yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'aras-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/aras/aras.module').then(m => m.ArasModule),
        data: {
          title: 'Aras Kargo Entegrasyonu - dotCREA',
          description: 'Aras Kargo ile hızlı ve güvenilir gönderimler yapın. dotCREA’nin entegrasyon çözümleri ile kargo süreçlerinizi optimize edin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'yurtici-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/yurtici/yurtici.module').then(m => m.YurticiModule),
        data: {
          title: 'Yurtiçi Kargo Entegrasyonu - dotCREA',
          description: 'Yurtiçi Kargo ile entegre olarak gönderim süreçlerinizi kolaylaştırın. dotCREA ile hızlı teslimatlar yapın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'mng-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/mng/mng.module').then(m => m.MngModule),
        data: {
          title: 'MNG Kargo Entegrasyonu - dotCREA',
          description: 'MNG Kargo ile entegrasyon sağlayarak kargo süreçlerinizi optimize edin. dotCREA ile tüm gönderimlerinizi kolayca yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ptt-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/ptt/ptt.module').then(m => m.PttModule),
        data: {
          title: 'PTT Kargo Entegrasyonu - dotCREA',
          description: 'PTT Kargo ile güvenilir gönderimler yapın. dotCREA’nin entegrasyon çözümleri ile kargo süreçlerinizi hızlandırın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ups-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/ups/ups.module').then(m => m.UpsModule),
        data: {
          title: 'UPS Kargo Entegrasyonu - dotCREA',
          description: 'UPS ile hızlı ve güvenilir gönderimler yaparak kargo süreçlerinizi kolaylaştırın. dotCREA ile işinizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'hepsijet-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/hepsijet/hepsijet.module').then(m => m.HepsijetModule),
        data: {
          title: 'Hepsijet Kargo Entegrasyonu - dotCREA',
          description: 'Hepsijet ile entegre kargo çözümleri sağlayarak gönderimlerinizi hızlandırın. dotCREA ile kargo süreçlerinizi optimize edin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'sendeo-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/sendeo/sendeo.module').then(m => m.SendeoModule),
        data: {
          title: 'Sendeo Kargo Entegrasyonu - dotCREA',
          description: 'Sendeo ile hızlı ve güvenilir gönderimler yapın. dotCREA’nin entegrasyon çözümleri ile kargo süreçlerinizi kolayca yönetin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'surat-kargo',
        loadChildren: () => import('./components/pages/integrations/cargo/surat/surat.module').then(m => m.SuratModule),
        data: {
          title: 'Surat Kargo Entegrasyonu - dotCREA',
          description: 'Surat Kargo ile entegrasyon sağlayarak tüm gönderimlerinizi hızlı bir şekilde yönetin. dotCREA ile işinizi büyütün.',
          robots: 'index, follow'
        }
      },
      {
        path: 'hakkimizda',
        loadChildren: () => import('./components/pages/support/about-page-one/about-page-one.module').then(m => m.AboutPageOneModule),
        data: {
          title: 'Hakkımızda - dotCREA',
          description: 'dotCREA hakkında daha fazla bilgi edinin. Pazaryeri entegrasyon çözümleri sunarak işletmelere destek veriyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'kariyer',
        loadChildren: () => import('./components/pages/support/career-page/career-page.module').then(m => m.CareerPageModule),
        data: {
          title: 'Kariyer Fırsatları - dotCREA',
          description: 'dotCREA’deki kariyer fırsatlarını keşfedin. Yenilikçi bir ekipte yer alarak kariyerinizi geliştirin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'bayilik',
        loadChildren: () => import('./components/pages/support/dealership-page/dealership-page.module').then(m => m.DealershipPageModule),
        data: {
          title: 'Bayilik Başvurusu - dotCREA',
          description: 'dotCREA bayiliği ile iş fırsatlarını değerlendirin. Başvurunuzu hemen yaparak avantajlardan yararlanın.',
          robots: 'index, follow'
        }
      },
      {
        path: 'kadin-girisimciler',
        loadChildren: () => import('./components/pages/support/women-entrepreneurs-page/women-entrepreneurs-page.module').then(m => m.WomenEntrepreneursPageModule),
        data: {
          title: 'Kadın Girişimciler - dotCREA',
          description: 'Kadın girişimcilerin desteklenmesi için sunduğumuz fırsatları keşfedin. dotCREA ile iş dünyasında güçlü bir yer edinin.',
          robots: 'index, follow'
        }
      },
      {
        path: 'oneri-sikayet',
        loadChildren: () => import('./components/pages/support/suggestion/suggestion.module').then(m => m.SuggestionModule),
        data: {
          title: 'Öneri ve Şikayetler - dotCREA',
          description: 'Öneri ve şikayetlerinizi iletmek için buradayız. dotCREA’yi daha iyi hale getirmek için geri bildirimlerinizi bekliyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'sss',
        loadChildren: () => import('./components/pages/faq-page/faq-page.module').then(m => m.FaqPageModule),
        data: {
          title: 'SSS - dotCREA',
          description: 'Sıkça sorulan sorulara göz atın. dotCREA ile ilgili merak ettiğiniz her şeyi buradan öğrenebilirsiniz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'cerez',
        loadChildren: () => import('./components/pages/resources/cookie/cookie.module').then(m => m.CookieModule),
        data: {
          title: 'Çerez Politikası - dotCREA',
          description: 'dotCREA’nin çerez politikası hakkında bilgi edinin. Gizliliğinizi korumak için çerez kullanımını detaylandırıyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'veri-guvenligi',
        loadChildren: () => import('./components/pages/resources/data-security/data-security.module').then(m => m.DataSecurityModule),
        data: {
          title: 'Veri Güvenliği - dotCREA',
          description: 'Veri güvenliğinizi sağlamak için aldığımız önlemleri öğrenin. dotCREA ile bilgileriniz güvende.',
          robots: 'index, follow'
        }
      },
      {
        path: 'gizlilik',
        loadChildren: () => import('./components/pages/resources/privacy/privacy.module').then(m => m.PrivacyModule),
        data: {
          title: 'Gizlilik Politikası - dotCREA',
          description: 'dotCREA’nin gizlilik politikası ile kişisel verilerinizi nasıl koruduğumuzu keşfedin. Gizliliğinizi önemsiyoruz.',
          robots: 'index, follow'
        }
      },
      {
        path: 'kullanici-sozlesmesi',
        loadChildren: () => import('./components/pages/resources/user-agreement/user-aggrement.module').then(m => m.UserAgreementModule),
        data: {
          title: 'Kullanıcı Sözleşmesi - dotCREA',
          description: 'dotCREA kullanıcı sözleşmesini okuyarak platformun kurallarını öğrenin. Kullanıcı deneyiminizi geliştirmek için buradayız.',
          robots: 'index, follow'
        }
      },
      {
        path: 'aydinlatma-metni',
        loadChildren: () => import('./components/pages/resources/contract/contract.module').then(m => m.ContractModule),
        data: {
          title: 'Aydınlatma Metni - dotCREA',
          description: 'dotCREA’nin aydınlatma metni ile kişisel verilerinizi nasıl işlediğimizi öğrenin. Şeffaf bir hizmet sunuyoruz.',
          robots: 'index, follow'
        }
      }
    ]
  },
  {
    path: 'en',
    children: [
      // {
      //   path: 'blog',
      //   loadChildren: () => import('./components/pages/blog/blog-list/blog-list.module').then(m => m.BlogListModule),
      //   data: {
      //     title: 'Blog - dotCREA',
      //     description: 'Latest blog posts and news about e-commerce, integration solutions, and digital commerce.',
      //     robots: 'index, follow'
      //   }
      // },
      // {
      //   path: 'blog/:slug',
      //   loadChildren: () => import('./components/pages/blog/blog-detail/blog-detail.module').then(m => m.BlogDetailModule),
      //   data: {
      //     robots: 'index, follow'
      //   }
      // },
      {
        path: 'pricing',
        loadChildren: () => import('./components/pages/e-commerce/pricing-page/pricing-page.module').then(m => m.PricingPageModule),
        data: {
          title: 'Pricing - dotCREA',
          description: 'Discover the most suitable pricing solutions for your marketplace integrations with dotCREA. We offer flexible pricing options to grow your business.',
          robots: 'index, follow'
        }
      },
      {
        path: 'integration-packages-pricing',
        loadChildren: () => import('./components/pages/pricing/integration-pricing/integration-pricing.module').then(m => m.IntegrationPricingModule),
        data: {
          title: 'Integration Packages Pricing - dotCREA',
          description: 'Affordable package options for marketplace, e-commerce, shipping, and accounting integrations. Customized solutions for your needs.',
          robots: 'index, follow'
        }
      },
      {
        path: 'contact',
        loadChildren: () => import('./components/pages/contact-page/contact-page.module').then(m => m.ContactPageModule),
        data: {
          title: 'Contact - dotCREA',
          description: 'Get in touch with us! We are here to provide more information about dotCREA or to request support. We are happy to answer your questions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'marketplace-integration',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-integration/page-solutions-integration.module').then(m => m.PageSolutionsIntegrationModule),
        data: {
          title: 'Marketplace Solutions - dotCREA',
          description: 'Increase your sales by facilitating easy integration with all marketplaces. Grow your business with dotCREA’s comprehensive marketplace solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shipping-integration',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-cargo/page-solutions-cargo.module').then(m => m.PageSolutionsCargoModule),
        data: {
          title: 'Shipping Integrations - dotCREA',
          description: 'Optimize your shipping processes. Make fast and reliable shipments with dotCREA’s shipping integrations.',
          robots: 'index, follow'
        }
      },
      {
        path: 'xml-integration',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-xml/page-solutions-xml.module').then(m => m.PageSolutionsXmlModule),
        data: {
          title: 'XML Integrations - dotCREA',
          description: 'Facilitate management of your products efficiently with XML integrations. Simplify all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'webservice-integration',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-webservice/page-solutions-webservice.module').then(m => m.PageSolutionsWebserviceModule),
        data: {
          title: 'Web Service Integrations - dotCREA',
          description: 'Accelerate your business processes with advanced web service integrations. Integrate all your data with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'analytics-integration',
        loadChildren: () => import('./components/pages/solutions/integrations/page-solutions-analytics/page-solutions-analytics.module').then(m => m.PageSolutionsAnalyticsModule),
        data: {
          title: 'Analytics Integrations - dotCREA',
          description: 'Guide your business with data analytics. Improve your performance and make strategic decisions with dotCREA’s analytics solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'catalog-management',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-catalog/page-solutions-catalog.module').then(m => m.PageSolutionsCatalogModule),
        data: {
          title: 'Catalog Management - dotCREA',
          description: 'Manage your product catalogs effectively. Gather all your product information on a single platform with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'stock-and-price-management',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-stock/page-solutions-stock.module').then(m => m.PageSolutionsStockModule),
        data: {
          title: 'Stock and Price Management - dotCREA',
          description: 'Easily manage your stock levels and prices. Control your business efficiently with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'accounting',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-accounting/page-solutions-accounting.module').then(m => m.PageSolutionsAccountingModule),
        data: {
          title: 'Pre-Accounting System - dotCREA',
          description: 'Simplify your accounting processes. Improve your financial management with dotCREA’s pre-accounting system.',
          robots: 'index, follow'
        }
      },
      {
        path: 'e-invoice-integration',
        loadChildren: () => import('./components/pages/solutions/e-commerce/page-solutions-einvoice/page-solutions-einvoice.module').then(m => m.PageSolutionsEinvoiceModule),
        data: {
          title: 'E-Invoice Transfer System - dotCREA',
          description: 'Accelerate your e-invoice processes. Manage your e-invoices securely with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'trendyol-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/trendyol-integration/trendyol-integration.module').then(m => m.TrendyolIntegrationModule),
        data: {
          title: 'Trendyol Integration - dotCREA',
          description: 'Quickly list your products by ensuring seamless integration with Trendyol. Increase your sales with dotCREA’s Trendyol integration.',
          robots: 'index, follow'
        }
      },
      {
        path: 'hepsiburada-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/hepsiburada-integration/hepsiburada-integration.module').then(m => m.HepsiburadaIntegrationModule),
        data: {
          title: 'Hepsiburada Integration - dotCREA',
          description: 'Add value to your sales by providing fast and reliable integration solutions with Hepsiburada. Grow your business with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'n11-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/n11-integration/n11-integration.module').then(m => m.N11IntegrationModule),
        data: {
          title: 'N11 Integration - dotCREA',
          description: 'Easily manage your products on the N11 platform. Increase your sales with dotCREA’s N11 integration.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ciceksepeti-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/ciceksepeti-integration/ciceksepeti-integration.module').then(m => m.CiceksepetiIntegrationModule),
        data: {
          title: 'Ciceksepeti Integration - dotCREA',
          description: 'Increase your sales through Ciceksepeti. Manage the entire process easily with dotCREA’s integration solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'pttavm-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/pttavm-integration/pttavm-integration.module').then(m => m.PttavmIntegrationModule),
        data: {
          title: 'PTTAVM Integration - dotCREA',
          description: 'Quickly list your products by integrating with PTTAVM. Easily manage all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'akakce-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/akakce-integration/akakce-integration.module').then(m => m.AkakceIntegrationModule),
        data: {
          title: 'Akakce Integration - dotCREA',
          description: 'Effectively manage your products through the Akakce platform. Benefit from the advantages of integration with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'amazon-integration',
        loadChildren: () => import('./components/pages/integrations/marketplace/amazon-integration/amazon-integration.module').then(m => m.AmazonIntegrationModule),
        data: {
          title: 'Amazon Integration - dotCREA',
          description: 'Gain more visibility on Amazon. Increase your sales with dotCREA’s Amazon integration.',
          robots: 'index, follow'
        }
      },
      {
        path: 'rgsyazilim-integration',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/rgs/rgs.module').then(m => m.RgsModule),
        data: {
          title: 'RGS Software Integration - dotCREA',
          description: 'Facilitate your business processes by integrating with RGS software. Provide seamless integration solutions with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'opencart-integration',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/opencart/opencart.module').then(m => m.OpencartModule),
        data: {
          title: 'OpenCart Integration - dotCREA',
          description: 'Effectively manage your products on the OpenCart platform. Speed up all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify',
        loadChildren: () => import('./components/pages/shopify/shopify-main.module').then(m => m.ShopifyMainModule),
        data: {
          title: 'Shopify E-Commerce Solutions | Store Setup, Theme Development & Integration - dotCREA',
          description: 'Professional Shopify services: Store setup, custom theme development, app integration, platform migration, and 24/7 technical support. Grow your e-commerce with Shopify experts.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-integration',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify/shopify.module').then(m => m.ShopifyModule),
        data: {
          title: 'Shopify Integration - dotCREA',
          description: 'Empower your e-commerce site by providing perfect integration with Shopify. Increase your sales with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-app-development',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/shopify-app-development/shopify-app-development.module').then(m => m.ShopifyAppDevelopmentModule),
        data: {
          title: 'Shopify App Development - dotCREA',
          description: 'Custom Shopify app development services for your store. We provide tailored solutions with modern technologies.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-plus',
        loadChildren: () => import('./components/pages/shopify-plus/shopify-plus/shopify-plus.module').then(m => m.ShopifyPlusModule),
        data: {
          title: 'What is Shopify Plus? - Enterprise E-commerce Platform',
          description: 'Enterprise-level e-commerce solution with Shopify Plus. Advanced features, high performance, and unlimited scalability for large businesses.',
          robots: 'index, follow'
        }
      },
      {
        path: 'enterprise-solutions',
        loadChildren: () => import('./components/pages/shopify-plus/enterprise-solutions/enterprise-solutions.module').then(m => m.EnterpriseSolutionsModule),
        data: {
          title: 'Enterprise E-commerce Solutions - Shopify Plus',
          description: 'Custom enterprise e-commerce solutions for large-scale businesses. ERP integration, custom development, and dedicated support.',
          robots: 'index, follow'
        }
      },
      {
        path: 'b2b-ecommerce',
        loadChildren: () => import('./components/pages/shopify-plus/b2b-ecommerce/b2b-ecommerce.module').then(m => m.B2bEcommerceModule),
        data: {
          title: 'B2B E-commerce Solutions - Shopify Plus',
          description: 'B2B e-commerce platform for wholesale and corporate customers. Custom pricing, flexible payments, and quick order features.',
          robots: 'index, follow'
        }
      },
      {
        path: 'wholesale-solutions',
        loadChildren: () => import('./components/pages/shopify-plus/wholesale-solutions/wholesale-solutions.module').then(m => m.WholesaleSolutionsModule),
        data: {
          title: 'Wholesale Solutions - Shopify Plus',
          description: 'Custom e-commerce platform for dealers and wholesale customers. Tiered pricing, dealer portal, and automated order management.',
          robots: 'index, follow'
        }
      },
      {
        path: 'shopify-plus-migration',
        loadChildren: () => import('./components/pages/shopify-plus/shopify-plus-migration/shopify-plus-migration.module').then(m => m.ShopifyPlusMigrationModule),
        data: {
          title: 'Shopify Plus Migration - Secure Platform Transfer',
          description: 'Seamless migration from your current platform to Shopify Plus. Zero data loss, SEO preservation, and minimal downtime.',
          robots: 'index, follow'
        }
      },
      {
        path: 'custom-development',
        loadChildren: () => import('./components/pages/shopify-plus/custom-development/custom-development.module').then(m => m.CustomDevelopmentModule),
        data: {
          title: 'Custom Shopify Plus Development Services',
          description: 'Custom Shopify Plus development for your business. Custom apps, API integrations, and headless commerce solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'wix-integration',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/wix/wix.module').then(m => m.WixModule),
        data: {
          title: 'Wix Integration - dotCREA',
          description: 'Explore dotCREA’s integration solutions to manage your products through Wix. Simplify your business.',
          robots: 'index, follow'
        }
      },
      {
        path: 'woocommerce-integration',
        loadChildren: () => import('./components/pages/integrations/ecommerce-infrastructure/woocommerce/woocommerce.module').then(m => m.WoocommerceModule),
        data: {
          title: 'WooCommerce Integration - dotCREA',
          description: 'Increase your sales by providing effective integration with WooCommerce. Manage all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'paytr-integration',
        loadChildren: () => import('./components/pages/integrations/payment/paytr-integration/paytr-integration.module').then(m => m.PaytrIntegrationModule),
        data: {
          title: 'PayTR Integration - dotCREA',
          description: 'Accelerate your payment processes with PayTR. Make secure payments with dotCREA’s integration solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'bizimhesap-integration',
        loadChildren: () => import('./components/pages/integrations/accounting/bizimhesap/bizimhesap.module').then(m => m.BizimhesapModule),
        data: {
          title: 'BizimHesap Integration - dotCREA',
          description: 'Facilitate your accounting transactions by providing seamless integration with BizimHesap. Grow your business with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'dia-integration',
        loadChildren: () => import('./components/pages/integrations/accounting/dia/dia.module').then(m => m.DiaModule),
        data: {
          title: 'DIA Integration - dotCREA',
          description: 'Optimize all your processes by integrating with DIA software. Accelerate your workflow with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'edm-integration',
        loadChildren: () => import('./components/pages/integrations/accounting/edm/edm.module').then(m => m.EdmModule),
        data: {
          title: 'EDM Integration - dotCREA',
          description: 'Facilitate your business processes by providing strong integration with EDM. Increase your efficiency with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'parasut-integration',
        loadChildren: () => import('./components/pages/integrations/accounting/parasut/parasut.module').then(m => m.ParasutModule),
        data: {
          title: 'Parasut Integration - dotCREA',
          description: 'Manage your accounting processes easily by providing integration with Parasut. Speed up all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'uyumsoft-integration',
        loadChildren: () => import('./components/pages/integrations/accounting/uyumsoft/uyumsoft.module').then(m => m.UyumsoftModule),
        data: {
          title: 'Uyumsoft Integration - dotCREA',
          description: 'Strengthen your business by integrating with Uyumsoft. Easily manage all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'aras-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/aras/aras.module').then(m => m.ArasModule),
        data: {
          title: 'Aras Cargo Integration - dotCREA',
          description: 'Quickly manage your shipments by integrating with Aras Cargo. Speed up all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'yurtici-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/yurtici/yurtici.module').then(m => m.YurticiModule),
        data: {
          title: 'Yurtiçi Cargo Integration - dotCREA',
          description: 'Provide effective management of your shipments with Yurtiçi Cargo. Accelerate your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'mng-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/mng/mng.module').then(m => m.MngModule),
        data: {
          title: 'MNG Cargo Integration - dotCREA',
          description: 'Facilitate your shipment processes with MNG Cargo. Speed up all your processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ptt-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/ptt/ptt.module').then(m => m.PttModule),
        data: {
          title: 'PTT Cargo Integration - dotCREA',
          description: 'Make reliable shipments with PTT Cargo. Accelerate your cargo processes with dotCREA’s integration solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'ups-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/ups/ups.module').then(m => m.UpsModule),
        data: {
          title: 'UPS Cargo Integration - dotCREA',
          description: 'Simplify your cargo processes by making fast and reliable shipments with UPS. Grow your business with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'hepsijet-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/hepsijet/hepsijet.module').then(m => m.HepsijetModule),
        data: {
          title: 'Hepsijet Cargo Integration - dotCREA',
          description: 'Speed up your shipments by providing integrated cargo solutions with Hepsijet. Optimize your cargo processes with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'sendeo-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/sendeo/sendeo.module').then(m => m.SendeoModule),
        data: {
          title: 'Sendeo Cargo Integration - dotCREA',
          description: 'Make fast and reliable shipments with Sendeo. Manage your cargo processes easily with dotCREA’s integration solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'surat-cargo',
        loadChildren: () => import('./components/pages/integrations/cargo/surat/surat.module').then(m => m.SuratModule),
        data: {
          title: 'Surat Cargo Integration - dotCREA',
          description: 'Manage all your shipments quickly by integrating with Surat Cargo. Grow your business with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'about',
        loadChildren: () => import('./components/pages/support/about-page-one/about-page-one.module').then(m => m.AboutPageOneModule),
        data: {
          title: 'About Us - dotCREA',
          description: 'Learn more about dotCREA. We support businesses by providing marketplace integration solutions.',
          robots: 'index, follow'
        }
      },
      {
        path: 'career',
        loadChildren: () => import('./components/pages/support/career-page/career-page.module').then(m => m.CareerPageModule),
        data: {
          title: 'Career Opportunities - dotCREA',
          description: 'Explore career opportunities at dotCREA. Develop your career by being part of an innovative team.',
          robots: 'index, follow'
        }
      },
      {
        path: 'dealership',
        loadChildren: () => import('./components/pages/support/dealership-page/dealership-page.module').then(m => m.DealershipPageModule),
        data: {
          title: 'Dealership Application - dotCREA',
          description: 'Evaluate business opportunities with dotCREA dealership. Apply now to benefit from the advantages.',
          robots: 'index, follow'
        }
      },
      {
        path: 'women-entrepreneurs',
        loadChildren: () => import('./components/pages/support/women-entrepreneurs-page/women-entrepreneurs-page.module').then(m => m.WomenEntrepreneursPageModule),
        data: {
          title: 'Women Entrepreneurs - dotCREA',
          description: 'Discover the opportunities we offer to support women entrepreneurs. Establish a strong presence in the business world with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'suggestion',
        loadChildren: () => import('./components/pages/support/suggestion/suggestion.module').then(m => m.SuggestionModule),
        data: {
          title: 'Suggestions and Complaints - dotCREA',
          description: 'We are here to hear your suggestions and complaints. We look forward to your feedback to improve dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'faq-page',
        loadChildren: () => import('./components/pages/faq-page/faq-page.module').then(m => m.FaqPageModule),
        data: {
          title: 'FAQ - dotCREA',
          description: 'Check out the frequently asked questions. You can learn everything you are curious about dotCREA here.',
          robots: 'index, follow'
        }
      },
      {
        path: 'cookie',
        loadChildren: () => import('./components/pages/resources/cookie/cookie.module').then(m => m.CookieModule),
        data: {
          title: 'Cookie Policy - dotCREA',
          description: 'Learn about dotCREA’s cookie policy. We detail the use of cookies to protect your privacy.',
          robots: 'index, follow'
        }
      },
      {
        path: 'data-security',
        loadChildren: () => import('./components/pages/resources/data-security/data-security.module').then(m => m.DataSecurityModule),
        data: {
          title: 'Data Security - dotCREA',
          description: 'Learn about the measures we take to ensure your data security. Your information is safe with dotCREA.',
          robots: 'index, follow'
        }
      },
      {
        path: 'privacy',
        loadChildren: () => import('./components/pages/resources/privacy/privacy.module').then(m => m.PrivacyModule),
        data: {
          title: 'Privacy Policy - dotCREA',
          description: 'Discover how we protect your personal data with dotCREA’s privacy policy. We value your privacy.',
          robots: 'index, follow'
        }
      },
      {
        path: 'user-agreement',
        loadChildren: () => import('./components/pages/resources/user-agreement/user-aggrement.module').then(m => m.UserAgreementModule),
        data: {
          title: 'User Agreement - dotCREA',
          description: 'Read dotCREA’s user agreement to learn the rules of the platform. We are here to improve your user experience.',
          robots: 'index, follow'
        }
      },
      {
        path: 'contract',
        loadChildren: () => import('./components/pages/resources/contract/contract.module').then(m => m.ContractModule),
        data: {
          title: 'Illumination Text - dotCREA',
          description: 'Learn how we process your personal data with dotCREA’s illumination text. We provide transparent services.',
          robots: 'index, follow'
        }
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
